/**
 * Tiny event bus so any surface (header icon, shortcuts, future entry points)
 * can open the global Command Bar without prop drilling or a new provider.
 */
const EVENT = "transportmate:command-bar-open";

export function openCommandBar() {
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function subscribeCommandBar(handler: () => void) {
  const listener = () => handler();
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
